import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    currentPage: selectors.currentPageSelector(state),
    pageSize: selectors.pageSizeSelector(state),
    error: selectors.errorSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isListLoading'),
    isNeedToFetchList: selectors.isNeedToFetchListSelector(state),
    tasksList: selectors.taskQueueListSelector(state),
    total: selectors.totalSelector(state),
    totalNewTasks: selectors.totalNewTasksSelector(state),
    totalInProgressTasks: selectors.totalInProgressTasksSelector(state)
  }
}

const mapDispatchToProps = {
  cancelTask: actions.cancelTask,
  changeCurrentPage: actions.changeCurrentPage,
  changePageSize: actions.changePageSize,
  fetchTasksList: actions.fetchTaskList,
  restartTask: actions.restartTask
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
